var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDepot = function SvgDepot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.75 21.998c0 .41-.34.75-.75.75H2a.749.749 0 1 1 0-1.5h20c.41 0 .75.33.75.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21 9.977v11.27H2.95L3 9.968c0-.61.28-1.19.77-1.57l7-5.44c.72-.57 1.74-.57 2.46 0l7 5.44c.49.38.77.96.77 1.58",
    opacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.5 8.248h-3c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3c.41 0 .75.34.75.75s-.34.75-.75.75"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M12.25 13.998a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 .75.75v8a.75.75 0 0 1-.75.75H7a.75.75 0 0 1-.75-.75v-6a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5H7.75v4.5h8.5v-6.5H13a.75.75 0 0 1-.75-.75",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M8.763 11.76A1.75 1.75 0 0 1 10 11.248h2a1.75 1.75 0 0 1 1.75 1.75v9a.75.75 0 0 1-1.5 0v-9a.25.25 0 0 0-.25-.25h-2a.25.25 0 0 0-.25.25v3a.75.75 0 0 1-1.5 0v-3c0-.465.184-.91.513-1.238",
    clipRule: "evenodd"
  })));
};
export default SvgDepot;